import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Simulador.css';

const TASA = 0.16; // 16% TEM

function calcCuota(monto, plazo) {
  if (!monto || !plazo) return 0;
  const r = TASA;
  const n = plazo;
  return (monto * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
}

const Simulador = ({ compact = false }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [monto, setMonto]   = useState(1000);
  const [plazo, setPlazo]   = useState(6);

  const cuota    = useMemo(() => calcCuota(monto, plazo), [monto, plazo]);
  const total    = useMemo(() => cuota * plazo, [cuota, plazo]);
  const intereses = useMemo(() => total - monto, [total, monto]);

  const handleSolicitar = () => {
    if (user) {
      navigate('/dashboard/nueva-solicitud');
    } else {
      navigate('/register');
    }
  };

  return (
    <div className={`simulador${compact ? ' simulador--compact' : ''}`}>
      {!compact && (
        <div className="simulador__header">
          <i className="fa-solid fa-calculator"></i>
          <h3>Simulador de Crédito</h3>
        </div>
      )}

      {/* Monto */}
      <div className="simulador__field">
        <div className="simulador__field-top">
          <label>Monto a solicitar</label>
          <span className="simulador__value">S/ {monto.toLocaleString()}</span>
        </div>
        <input
          type="range"
          min={500} max={2000} step={100}
          value={monto}
          onChange={(e) => setMonto(Number(e.target.value))}
          className="simulador__slider"
        />
        <div className="simulador__range-hints">
          <span>S/ 500</span><span>S/ 2,000</span>
        </div>
      </div>

      {/* Plazo */}
      <div className="simulador__field">
        <div className="simulador__field-top">
          <label>Plazo</label>
          <span className="simulador__value">{plazo} {plazo === 1 ? 'mes' : 'meses'}</span>
        </div>
        <input
          type="range"
          min={1} max={12} step={1}
          value={plazo}
          onChange={(e) => setPlazo(Number(e.target.value))}
          className="simulador__slider"
        />
        <div className="simulador__range-hints">
          <span>1 mes</span><span>12 meses</span>
        </div>
      </div>

      {/* Result */}
      <div className="simulador__result">
        <div className="simulador__cuota">
          <span>Cuota mensual estimada</span>
          <strong>S/ {cuota.toFixed(2)}</strong>
        </div>
        <div className="simulador__breakdown">
          <div>
            <span>Total a pagar</span>
            <b>S/ {total.toFixed(2)}</b>
          </div>
          <div>
            <span>Intereses</span>
            <b>S/ {intereses.toFixed(2)}</b>
          </div>
          <div>
            <span>Tasa mensual</span>
            <b>16%</b>
          </div>
        </div>
      </div>

      {/* CTA */}
      <button className="simulador__btn" onClick={handleSolicitar}>
        <i className="fa-solid fa-paper-plane"></i>
        {user ? 'Crear solicitud' : 'Solicitar ahora'}
      </button>

      {!user && (
        <p className="simulador__login-hint">
          ¿Ya tienes cuenta?{' '}
          <button className="simulador__link" onClick={() => navigate('/login')}>
            Inicia sesión
          </button>
        </p>
      )}

      <p className="simulador__disclaimer">
        * Simulación referencial. Tasa sujeta a evaluación crediticia.
      </p>
    </div>
  );
};

export default Simulador;
